var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Modal",
    {
      attrs: { title: "Create new Corpus", closeMessage: "Cancel" },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
        confirm: _vm.createCorpus,
      },
    },
    [
      _vm.errorMessage
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _c(
              "a",
              {
                staticClass: "close",
                attrs: { href: "#", "aria-label": "close" },
                on: {
                  click: function ($event) {
                    _vm.errorMessage = ""
                  },
                },
              },
              [_vm._v("×")]
            ),
            _vm._v("\n\t\t" + _vm._s(_vm.errorMessage) + "\n\t"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticStyle: { width: "100%" } }, [
            _vm._v("Corpus Name "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.corpusName,
                  expression: "corpusName",
                },
              ],
              staticClass: "form-control",
              attrs: {
                id: "corpus_name",
                maxlength: "80",
                placeholder: "Corpus name",
              },
              domProps: { value: _vm.corpusName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.corpusName = $event.target.value
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c(
              "label",
              {
                attrs: {
                  for: "corpus_document_type",
                  title:
                    "The format of the documents that will be stored in the corpus",
                },
              },
              [_vm._v("Document Format")]
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("SelectPicker", {
              attrs: {
                id: "corpus_document_type",
                hideEmpty: "",
                allowHtml: "",
                placeholder: "Select a document format...",
                container: "body",
                "data-menu-width": "auto",
                "data-width": "100%",
                loading: _vm.loading,
                options: _vm.formatOptions,
              },
              model: {
                value: _vm.documentType,
                callback: function ($$v) {
                  _vm.documentType = $$v
                },
                expression: "documentType",
              },
            }),
            _vm._v(" "),
            _vm.selectedFormat
              ? _c(
                  "small",
                  {
                    staticClass: "text-muted",
                    staticStyle: { display: "block", padding: "8px 8px 0px" },
                  },
                  [_vm._v(_vm._s(_vm.selectedFormat.description))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedFormat && _vm.selectedFormat.helpUrl
              ? _c(
                  "small",
                  { staticStyle: { display: "block", padding: "8px 8px 0px" } },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          target: "_blank",
                          href: _vm.selectedFormat.helpUrl,
                        },
                      },
                      [_vm._v("More information")]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }